import React from "react";
import DMModuleSubtopic from "../DMModuleSubtopic";

const PlanarNonPlanarModule = () => (
  <DMModuleSubtopic
    title="Planar and Non-Planar Graphs"
    videos={[
      "https://www.youtube.com/embed/9PdPlk9ahjY",
      "https://www.youtube.com/embed/kTOaRSIN5A4"
    ]}
    takeaways={[]}
    questions={[
      {
        text: "Verify whether the complete graph with 5 vertices is planar or non-planar."
      },
      {image:"/dm_36.png"},
    ]}
    exampleVideos={[]}
  />
);

export default PlanarNonPlanarModule;
